'use client';

import { VenueDetailsCard } from '@/tournament/components/details/VenueDetailsCard';
import { TourneyLocation } from '@/types/tournaments.types';

interface VenuesProps {
	locations: TourneyLocation[];
}
export const VenuesList = ({ locations }: VenuesProps) => {
	return (
		<div className="flex flex-col gap-4 sm:gap-6">
			{locations.length >= 2 && (
				<div>
					This tournament is played at different venues. Please refer to your registration confirmation to locate your tournament venue.
				</div>
			)}
			{locations.map((location, i) => (
				<VenueDetailsCard
					key={i}
					title={location.Venue}
					isPrimary={location.IsPrimary}
					streetAddr={location.StreetAddress}
					city={location.City}
					state={location.StateTitle}
					zip={Number(location.Zip)}
					parkingFee={location.IsParkingFee}
					parkingInfo={location.ParkingInformation}
					surfaceType={location.SurfaceTypeTitle}
					courtsCount={location.NumberOfCourts}
					ballUsed={location.BallUsed}
					ballURL={location.BallURL}
					playAreaType={location.PlayAreaTypeTitle}
					netType={location.NetTypeTitle}
					isSingleVenue={locations.length === 1}
					lat={Number(location.Latitude)}
					lng={Number(location.Longitude)}
					country={location.CountryTitle}
				/>
			))}
		</div>
	);
};
